import tt from '@/i18n/utils/translateText';

export const ROUTE_NAME = {
  contractors: 'contractors',
  contractorPersonalAccountSignIn: 'contractorPersonalAccountSignIn',
  contractorPersonalAccountUnsubscribe: 'contractorPersonalAccountUnsubscribe',
  contractorPersonalAccountRuns: 'contractorPersonalAccountRuns',
  contractorPersonalAccountCurrentRuns: 'contractorPersonalAccountCurrentRuns',
  contractorPersonalAccountPlannedRuns: 'contractorPersonalAccountPlannedRuns',
  contractorPersonalAccountFinishedRuns: 'contractorPersonalAccountFinishedRuns',
  contractorPersonalAccountRun: 'contractorPersonalAccountRun',
  contractorPersonalAccountIncidents: 'contractorPersonalAccountIncidents',
  digitalQueue: 'digitalQueue',
  digitalQueueBooking: 'digitalQueueBooking',
  digitalQueueSchedule: 'digitalQueueSchedule',
};

export enum ERunsTableStatus {
  onExecution = 'on_execution',
  completed = 'completed',
  planned = 'planned',
}

export enum ERunsTableTypes {
  contractorPersonalAccountCurrentRunsTable = 'contractorPersonalAccountCurrentRunsTable',
  contractorPersonalAccountFinishedRunsTable = 'contractorPersonalAccountFinishedRunsTable',
  contractorPersonalAccountPlannedRunsTable = 'contractorPersonalAccountPlannedRunsTable',
}

export enum EContractorCategory {
  customer = 'customer',
  consigneeOrConsignor = 'consigneeOrConsignor',
  payer = 'payer',
}

export const CONTRACTOR_CATEGORY_TRANSLATIONS = {
  [EContractorCategory.customer]: 'customer',
  [EContractorCategory.consigneeOrConsignor]: 'consignee_or_consignor',
  [EContractorCategory.payer]: 'payer',
};

export const CONTRACTOR_CATEGORIES = [{
  name: tt('shared.customer'),
  id: EContractorCategory.customer,
}, {
  name: tt('shared.contractor'),
  id: CONTRACTOR_CATEGORY_TRANSLATIONS[EContractorCategory.consigneeOrConsignor],
}, {
  name: tt('shared.payer'),
  id: EContractorCategory.payer,
}];

export enum ERunTypes {
  current = 'current',
  planned = 'planned',
  finished = 'finished',
}

export const DEFAULT_CONTRACTOR_ACCOUNT_PATH = '/contractor_personal_account/runs';
